import { timezoneGroups, zones } from "@entities/profile/model/timezone-picker/tzdata";
import { tzOffset } from "@date-fns/tz";


export function findTimezoneGroupByEng(engTimezone) {
	for (const group of timezoneGroups) {
		const foundZone = group.zones.find(zone => zone.eng === engTimezone);
		if (foundZone) {
			return group;
		}
	}
	return null;
}

export function findGroupNameByEng(engTimezone) {
		return findTimezoneGroupByEng(engTimezone)?.name ?? null;
	}

export	const buildTimezones = (compareDate, tz) => {
		if(!tz){
			return null
		}
		const mskOffset = tzOffset('Europe/Moscow', compareDate) / 60;
		const zoneName = zones.find((o) => o.eng === tz);
		if (!zoneName) {
			return null;
		}

		const zoneOffset = tzOffset(zoneName.eng, compareDate) / 60;
		const offsetFromMSK = zoneOffset - mskOffset;

		const label = `(МСК${offsetFromMSK === 0 ? '' : (offsetFromMSK > 0 ? ' +' : '') + offsetFromMSK})`;
			
		return label;
	};
